import ga from "@toolkit/Framework/Common/GoogleAnalytics";
import { TrackEventBaseParameters } from "@toolkit/Framework/Common/GoogleAnalytics/trackers/trackEvent";

/* ---------------------------------------------------------------------------------------------------- */
// Toolkit Custom Event
/* ---------------------------------------------------------------------------------------------------- */

export interface TrackBillingInfoChangedParameters extends TrackEventBaseParameters {}

const trackBillingInfoChanged = (
    parameters: TrackBillingInfoChangedParameters,
    options?: Toolkit.GoogleAnalytics.Options,
) => {
    return ga.track.event({ action: "billing_info_changed", ...parameters }, options);
};

export default trackBillingInfoChanged;
